"use client";

import useTranslate from "@app/_hooks/useTranslate";
import { Paragraph } from "@ui/paragraph";
import type { StockStatusProps, UNKNOWN } from "../Stock.types";
import { stockStatusVariants } from "../Stock.utils";
import StockIndicator from "./StockIndicator";

export default function Unknown({
  status,
  config,
}: {
  status: UNKNOWN;
  config: StockStatusProps;
}) {
  const t = useTranslate();
  const { type, className } = config;

  const { root: rootSlot } = stockStatusVariants({ type });

  if (type === "pdp") {
    return (
      <div className={className}>
        <div className={rootSlot({ className })}>
          <StockIndicator status={status.code} />
          <Paragraph className="inline-block">{t("unknown")}</Paragraph>
        </div>
      </div>
    );
  }
  return null;
}
